<template>
  <div v-if="env === 'production'">
    <a :href="$t('https://www.ores.be')" class="icons logo-ores"></a>
  </div>
  <div v-else>
    <router-link :to="{ name: 'home-page' }" class="icons logo-ores"></router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      env: process.env.NODE_ENV
    }
  }
}
</script>
